import { useCornerRadii } from './useCornerRadii';

import { createSelectedHook } from '~/core/utils';
import { selectSelectedCornerRadius } from '~/redux/slices/cornerRadii';

export const useSelectedCornerRadius = createSelectedHook({
  selector: selectSelectedCornerRadius,
  apiQueryHook: useCornerRadii,
  shouldReturnDefault: ({ selectedValue, apiHookResponse }) => {
    const isInApiResponse = apiHookResponse.cornerRadii.find(
      (cornerRadius) => cornerRadius.productId === selectedValue?.productId
    );

    return !isInApiResponse || !selectedValue;
  },
  selectDefaultValue: ({ apiHookResponse }) => apiHookResponse.cornerRadii[0],
});
